module.exports = __webpack_public_path__ + "images/icons/icon-step-confirmation-507e4dc3.svg";